import { GetRepaymentDetailReq } from "@/pbjs/xcommon/ticket_pb";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { ticketClient } from "@/api/ticketClient";

interface ITicketLogReq {
    ticketitemid: number;
    date: string;
    adminuid: number;
}
export function getRepaymentDetail(arg: ITicketLogReq) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request = new GetRepaymentDetailReq();
      request.setCommonin(setCommon());
      request.setStatsdate(arg.date); //统计日期
      request.setTicketitemid(arg.ticketitemid);
      request.setAdminuid(arg.adminuid);//员工id
      await ticketClient.getRepaymentDetail(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
